/* ============================================================
   Product detail page v2 — sales-page template
   Order: carousel + ATF copy → offer (quantity breaks) →
   mini-FAQ → reviews → education (how it works, comparison,
   guarantee) → full FAQ → final CTA card
   ============================================================ */
(() => {
'use strict';
const $=(s,c=document)=>c.querySelector(s),$$=(s,c=document)=>[...c.querySelectorAll(s)];
const P=window.PRODUCTS||[];
const D=window.PDP_DATA||{shared:{},categories:{},overrides:{}};
/* Handle resolution, most authoritative first:
   1. PD_PRODUCT_HANDLE — emitted by templates/product.liquid
   2. /products/<handle> — Shopify's canonical URL
   3. ?p=<handle>        — the static build's query string
   Falling back to P[0] would silently render the wrong product, so bail out. */
const handle = window.PD_PRODUCT_HANDLE
  || (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1]
  || new URLSearchParams(location.search).get('p');
/* Product titles, categories and image URLs are merchant-authored in Shopify
   Admin and get interpolated into innerHTML below. Escaping them keeps any
   stray markup (or an injected tag) inert rather than parsed. */
const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g,
  c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

const p = P.find(x => x.handle === decodeURIComponent(handle || ''));
const root=$('[data-pdp]');
if(!p||!root)return;
document.title=`${p.title} — Peptides Direct`;

const S=D.shared, ov=D.overrides[p.handle]||{};
const catBlurb=D.categories[p.category]||'a research peptide';
const h1=ov.h1||`Verified 99%+ Pure ${p.title} — COA Published Before You Buy`;

/* ---- carousel slides: hero → packaging → shipped ---- */
const slides=[
  {img:p.img, alt:`${p.title} research vial`, cap:''},
  {img:PD_ASSET+"img-pdp-slide-package.webp", alt:`${p.title} vial with protective mailer packaging`, cap:'Ships protected, discreet packaging', fit:'cover', pos:'bottom'},
  {img:PD_ASSET+"img-pdp-slide-shipped24.webp", alt:'Shipped within 24 hours', cap:'', fit:'cover', pos:'top'},
];

/* ---- variants / offer tiers ---- */
const strengths=[...new Set(p.variants.map(v=>v.strength))];
const packs=['Buy 1','Buy 5','Buy 10'].filter(pk=>p.variants.some(v=>v.pack===pk));
let sel={strength:strengths[0],pack:packs.length>1?packs[1]||packs[0]:p.variants[0].pack};
const variant=()=>p.variants.find(v=>v.strength===sel.strength&&v.pack===sel.pack)||p.variants.find(v=>v.strength===sel.strength)||p.variants[0];
const vialCount=pk=>+(pk.match(/\d+/)||[1])[0];
const unitPrice=st=>{const v=p.variants.find(x=>x.strength===st&&vialCount(x.pack)===1)||p.variants.find(x=>x.strength===st);return v?v.price/vialCount(v.pack):0;};

function tierCard(v){
  const n=vialCount(v.pack), full=unitPrice(v.strength)*n;
  const save=full>v.price+0.01?Math.round((1-v.price/full)*100):0;
  const tag=n===5?'<span class="tier__flag">Most Popular</span>':n===10?'<span class="tier__flag tier__flag--best">Best Value</span>':'';
  return `<button class="tier" data-pack="${v.pack}" aria-pressed="${sel.pack===v.pack}">
    ${tag}
    <span class="tier__n">${v.pack==='Buy 1'?'1 vial':n+' vials'}</span>
    <span class="tier__price">£${v.price.toFixed(2)}</span>
    <span class="tier__unit">£${(v.price/n).toFixed(2)} / vial${save?` · <b>save ${save}%</b>`:''}</span>
  </button>`;
}

const check='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="9"/></svg>';

/* ---- related products rail: same category first, bestsellers fill ---- */
function relatedHTML(){
  const rel=P.filter(x=>x.handle!==p.handle&&x.category===p.category);
  const fill=P.filter(x=>x.handle!==p.handle&&x.bestseller&&rel.indexOf(x)<0);
  const picks=rel.concat(fill).slice(0,4);
  if(!picks.length)return '';
  return `
    <h2 class="h2">Researchers also verify</h2>
    <div class="pgrid pdp__related">
      ${picks.map(r=>`
        <article class="pcard">
          <a class="pcard__media" href="/products/${encodeURIComponent(r.handle)}">
            ${r.bestseller?'<span class="pcard__badge">Best Seller</span>':''}
            <img src="${encodeURI(r.img)}" alt="${esc(r.title)} research vial" loading="lazy">
          </a>
          <div class="pcard__body">
            <span class="pcard__cat">${esc(r.category)}</span>
            <h3 class="pcard__title"><a href="/products/${encodeURIComponent(r.handle)}">${esc(r.title)}</a></h3>
            <div class="pcard__foot">
              <span class="pcard__price">£${(+r.from).toFixed(2)} <small>from</small></span>
              <a class="btn btn--ink-fill btn--sm" href="/products/${encodeURIComponent(r.handle)}">View ↗</a>
            </div>
          </div>
        </article>`).join('')}
    </div>`;
}
const faqItem=([q,a])=>`<details class="faq"><summary>${q}</summary><p>${a}</p></details>`;
const mark=v=>v==='yes'?'<span class="cmp__yes">✓</span>':v==='no'?'<span class="cmp__no">✕</span>':'<span class="cmp__unk">?</span>';

/* ---- render ---- */
root.innerHTML=`
  <div class="pdp__media-col">
    <div class="pdp__media" data-carousel>
      <div class="car__track" data-car-track>
        ${slides.map((s,i)=>`<figure class="car__slide"><img src="${s.img}" alt="${s.alt}" ${i?'loading="lazy"':''} ${s.fit==='cover'?`style="object-fit:cover;padding:0;object-position:center ${s.pos||'center'}"`:''} onerror="this.closest('.car__slide').remove()">${s.cap?`<figcaption>${s.cap}</figcaption>`:''}</figure>`).join('')}
      </div>
      <button class="car__btn car__btn--l" data-car="-1" aria-label="Previous image">‹</button>
      <button class="car__btn car__btn--r" data-car="1" aria-label="Next image">›</button>
      <div class="car__dots" data-car-dots></div>
    </div>
    <div class="car__thumbs" data-car-thumbs></div>
  </div>

  <div class="pdp__buy">
    <div class="pdp__rating" aria-label="Rated 5 out of 5 by verified users">
      <span class="pdp__stars">★★★★★</span><span class="pdp__count">Rated by verified users</span>
    </div>
    <span class="pdp__cat">${esc(p.category)}${p.bestseller?' · Best Seller':''}</span>
    <h1>${esc(p.title)}</h1>
    <p class="pdp__headline">Shipped Within 24 Hours</p>
    <ul class="pdp__trust">${(S.bullets||[]).map(b=>`<li>${check}${b}</li>`).join('')}</ul>

    ${strengths.length>1?`<div class="opt"><span class="opt__label">Strength</span><div class="opt__row" data-strengths></div></div>`:''}
    ${packs.length>1?`<div class="opt"><span class="opt__label">Bundle & save</span><div class="tiers" data-tiers></div></div>`:''}
    <div class="pdp__price" data-price>£${variant().price.toFixed(2)}</div>
    <button class="btn btn--fill btn--block" data-add>Add To Cart ↗</button>
    <p class="pdp__reassure">${check}<span>Published COA Guarantee · <a href="/pages/coas" style="color:inherit;text-decoration:underline">COA published online</a> · Same-day dispatch before 3pm</span></p>

    <div class="pdp__minifaq">${(S.faqMini||[]).map(faqItem).join('')}</div>
    <p class="pdp__ruo">${S.ruoNote||''}</p>
  </div>`;

/* wide sections live OUTSIDE the grid so the sticky media column
   can't ride down over them (Chrome stickies across the full grid) */
/* ---- research section: mechanism of action + published studies ---- */
const RD=window.RESEARCH_DATA||{compounds:{},fallback:{}};
const rsrch=RD.compounds[p.handle]||RD.fallback[p.category]||null;
const researchHTML=(!rsrch||!(rsrch.studies||[]).length)?'':`
  <section class="sci">
    <header class="sci__head">
      <span class="sci__eyebrow">The evidence base</span>
      <h2 class="h2">What the literature says about ${p.title}</h2>
      <p class="sci__intro">Peer-reviewed research on the compound itself — mechanism first, then the studies that characterised it. Summarised for researchers, with the original citation on every card.</p>
    </header>

    <div class="moa">
      <span class="moa__label">Mechanism of action</span>
      <p class="moa__text">${rsrch.mech}</p>
      <ol class="moa__chain">
        ${(rsrch.pathway||[]).map((s,i)=>`<li class="moa__step"><span class="moa__n">${i+1}</span><span>${s}</span></li>`).join('')}
      </ol>
    </div>

    <div class="sci__grid">
      ${rsrch.studies.map(s=>`
        <article class="sci__card">
          <div class="sci__meta"><span class="sci__year">${s.year}</span><span class="sci__journal">${s.journal}</span></div>
          <h3 class="sci__title">${s.title}</h3>
          ${s.stat?`<div class="sci__stat"><b>${s.stat}</b><span>${s.statLabel||''}</span></div>`:''}
          <p class="sci__finding">${s.finding}</p>
          <p class="sci__model"><span>Model</span>${s.model}</p>
        </article>`).join('')}
    </div>

    <p class="sci__note">Citations describe published findings on the compound in laboratory and clinical research settings. They are not claims about this product, and nothing here is medical advice or an indication of intended use. Research Use Only.</p>
  </section>`;

root.insertAdjacentHTML('afterend',`
  <section class="pdp__wide">
    ${researchHTML}

    <h2 class="h2">What researchers say</h2>
    <div class="rev__grid">
      ${(S.reviews||[]).map(([n,t,txt])=>`<figure class="rev"><div class="rev__stars">★★★★★</div><blockquote>${txt}</blockquote><figcaption><b>${n}</b> · ${t}</figcaption></figure>`).join('')}
    </div>

    <h2 class="h2">How every vial earns its listing</h2>
    <p class="pdp__edu-intro">${p.title} is ${catBlurb}.${p.desc?' '+p.desc+'.':''} Here is exactly what happens before it reaches you:</p>
    <ol class="steps">
      ${(S.steps||[]).map(([t,b],i)=>`<li class="step"><span class="step__n">0${i+1}</span><h3>${t}</h3><p>${b}</p></li>`).join('')}
    </ol>

    <h2 class="h2">Us vs. the grey market</h2>
    <div class="cmp__scroll"><table class="cmp">
      <thead><tr><th></th>${(S.compare?.cols||[]).map(c=>`<th>${c}</th>`).join('')}</tr></thead>
      <tbody>${(S.compare?.rows||[]).map(r=>`<tr><td>${r[0]}</td><td>${mark(r[1])}</td><td>${mark(r[2])}</td></tr>`).join('')}</tbody>
    </table></div>

    <div class="guarantee">
      <h2 class="h2">${S.guarantee?.[0]||''}</h2>
      <p>${S.guarantee?.[1]||''}</p>
    </div>

    <h2 class="h2">Frequently asked</h2>
    <div class="pdp__fullfaq">${(S.faqFull||[]).map(faqItem).join('')}</div>

    ${relatedHTML()}

    <div class="offer-card">
      <h2 class="h2">Ready when your research is</h2>
      <p>Verified ${p.title}, certificate already published, dispatched today if you order before 3pm.</p>
      <div class="offer-card__row">
        <span class="pdp__price" data-price2>£${variant().price.toFixed(2)}</span>
        <button class="btn btn--fill" data-add2>Add To Cart ↗</button>
      </div>
      <p class="pdp__ruo">${S.ruoNote||''}</p>
    </div>
  </section>`);

/* ---- sticky mobile add-to-cart bar ----
   Appears once the primary buy button scrolls out of view on small
   screens, so the offer + price stay one tap away down the long page. */
(function stickyBar(){
  const primary=$('[data-add]');
  if(!primary)return;
  const bar=document.createElement('div');
  bar.className='pdp-sticky';
  bar.innerHTML=`
    <div class="pdp-sticky__info">
      <span class="pdp-sticky__name">${p.title}</span>
      <span class="pdp-sticky__price" data-price3>£${variant().price.toFixed(2)}</span>
    </div>
    <button class="btn btn--fill pdp-sticky__btn" data-add3>Add To Cart ↗</button>`;
  document.body.appendChild(bar);
  $('[data-add3]',bar).onclick=()=>window.PDCart.add(p,variant());
  const io=new IntersectionObserver(es=>{
    es.forEach(e=>bar.classList.toggle('is-on',!e.isIntersecting&&e.boundingClientRect.top<0));
  },{threshold:0});
  io.observe(primary);
})();

/* ---- carousel behaviour ---- */
(function carousel(){
  const track=$('[data-car-track]'),dots=$('[data-car-dots]'),thumbs=$('[data-car-thumbs]');
  if(!track)return;
  const n=()=>track.children.length;
  let i=0;
  const renderDots=()=>{dots.innerHTML=[...track.children].map((_,k)=>`<button data-dot="${k}" aria-label="Image ${k+1}" class="${k===i?'on':''}"></button>`).join('');
    $$('[data-dot]',dots).forEach(d=>d.onclick=()=>go(+d.dataset.dot));};
  const renderThumbs=()=>{if(!thumbs)return;
    thumbs.innerHTML=[...track.children].map((sl,k)=>{const im=sl.querySelector('img');return `<button data-thumb="${k}" aria-label="Image ${k+1}" class="${k===i?'on':''}"><img src="${im?im.getAttribute('src'):''}" alt="" loading="lazy"></button>`;}).join('');
    $$('[data-thumb]',thumbs).forEach(t=>t.onclick=()=>go(+t.dataset.thumb));};
  const go=k=>{i=(k+n())%n();track.style.transform=`translateX(-${i*100}%)`;renderDots();renderThumbs();};
  $$('[data-car]').forEach(b=>b.onclick=()=>go(i+(+b.dataset.car)));
  let x0=null;
  track.addEventListener('pointerdown',e=>{x0=e.clientX});
  track.addEventListener('pointerup',e=>{if(x0===null)return;const dx=e.clientX-x0;if(Math.abs(dx)>40)go(i+(dx<0?1:-1));x0=null;});
  // slides with missing images remove themselves; rebuild dots/thumbs after load settles
  setTimeout(()=>{if(i>=n())i=0;go(i);},1200);
  renderDots();renderThumbs();
})();

/* ---- selectors ---- */
function syncPrice(){const v=variant();['[data-price]','[data-price2]','[data-price3]'].forEach(s=>{const el=$(s);if(el)el.textContent='£'+v.price.toFixed(2);});}
function renderTiers(){
  const wrap=$('[data-tiers]');if(!wrap)return;
  wrap.innerHTML=packs.map(pk=>tierCard(p.variants.find(v=>v.strength===sel.strength&&v.pack===pk)||{pack:pk,strength:sel.strength,price:0})).join('');
  $$('.tier',wrap).forEach(b=>b.onclick=()=>{sel.pack=b.dataset.pack;$$('.tier',wrap).forEach(x=>x.setAttribute('aria-pressed',x===b));syncPrice();});
}
(function strengthChips(){
  const wrap=$('[data-strengths]');if(!wrap)return;
  wrap.innerHTML=strengths.map(v=>`<button class="opt__btn" data-v="${v}" aria-pressed="${sel.strength===v}">${v}</button>`).join('');
  $$('.opt__btn',wrap).forEach(b=>b.onclick=()=>{sel.strength=b.dataset.v;$$('.opt__btn',wrap).forEach(x=>x.setAttribute('aria-pressed',x===b));renderTiers();syncPrice();});
})();
renderTiers();
[['[data-add]'],['[data-add2]']].forEach(([s])=>{const b=$(s);if(b)b.onclick=()=>window.PDCart.add(p,variant());});

/* ---- scroll reveals for the long-form sections ----
   Give the wide-section cards the homepage reveal vocabulary and hand
   them to the shared observer (fable5-pages.js exposes PDReveal). */
(function reveals(){
  if(!window.PDReveal)return;
  const nodes=$$('.pdp__wide .h2, .pdp__wide .rev, .pdp__wide .step, .pdp__wide .sci__card, .pdp__wide .moa, .pdp__wide .guarantee, .pdp__wide .offer-card, .pdp__wide .pcard');
  nodes.forEach((el,i)=>{
    el.classList.add('pd-rev');
    // stagger siblings inside grids, not headings
    if(!el.classList.contains('h2'))el.setAttribute('data-d',String(1+(i%3)));
  });
  window.PDReveal(nodes);
})();
})();
